import React, { useEffect, useState } from 'react';
import ProduktFormular from './ProduktFormular';
import { useParams, useNavigate } from 'react-router-dom';

export default function BearbeitenFormular() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [produkt, setProdukt] = useState(null);
  const [kategorien, setKategorien] = useState([]);
  const [einheiten, setEinheiten] = useState([]);
  const [orte, setOrte] = useState([]);

  // Produktdaten laden
  useEffect(() => {
    fetch(`https://app.satoha.de/service/?action=get-vorrat&type=id&value=${id}`)
      .then(res => res.json())
      .then(data => setProdukt(data));
  }, [id]);

  // Stammdaten laden
  useEffect(() => {
    fetch('https://app.satoha.de/service/?modus=get-vorrat-runtimedata')
      .then(res => res.json())
      .then(data => {
        setKategorien(data.kategorien || []);
        setEinheiten(data.einheiten || []);
        setOrte(data.orte || []);
      });
  }, []);

  // Update-Handler
    const handleUpdate = async (formData) => {
    try {
        const payload = {
        modus: "update-item",
        item_dbid: formData.id,
        item_name: formData.name,
        item_gruppe: formData.gruppe_id, // oder formData.gruppe, je nach Datenstruktur
        item_menge: formData.menge,
        item_einheit_id: formData.einheit_id,
        item_kategorie_id: formData.kategorie_id,
        item_ort_id: formData.lagerort_id || formData.ort_id,
        item_verfallsdatum: formData.verfallsdatum,
        };

        const response = await fetch('https://app.satoha.de/service/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (result.success) {
            setTimeout(() => navigate('/'), 1000);
            return { success: true, message: result.message || 'Gespeichert!' };
        } else {
            return { success: false, message: result.message || 'Speichern fehlgeschlagen.' };
        }
    } catch (err) {
        return { success: false, message: 'Netzwerkfehler beim Speichern.' };
    }
    };


  // Erst rendern, wenn Daten geladen
  if (!produkt) return <div>Lade Daten...</div>;

  return (
    <ProduktFormular
      initialValues={produkt}
      onSubmit={handleUpdate}
      mode="edit"
      kategorien={kategorien}
      einheiten={einheiten}
      orte={orte}
      title="Produkt bearbeiten"
    />
  );
}
